import { Client } from 'typesense'

export function tsClient() {
  const host = import.meta.env.VITE_TYPESENSE_HOST
  const apiKey = import.meta.env.VITE_TYPESENSE_SEARCH_KEY
  return new Client({
    nodes: [{
      host, // For Typesense Cloud use xxx.a1.typesense.net
      port: 443, // For Typesense Cloud use 443
      protocol: 'https' // For Typesense Cloud use https
    }],
    apiKey,
    connectionTimeoutSeconds: 2,
    cacheSearchResultsForSeconds: 60
  })
}
